module.exports = __webpack_public_path__ + "static/css-page-8-5-0c3040b46c1582af2a51712e75dc833f.jpg";